<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <div class="lv-slider-label-value">
      <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                        [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                        [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                        [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"></lv-label-tooltip>
      <div class="lv-input-slider">
        <lv-material-form-input [unit]="uiArtefakt.Einheit" [hint]="uiArtefakt.Hinweis"
                                [meldung]="uiArtefakt.UIMeldung | meldung: 'Fehler': true "
                                lvMinMaxValidator [minValue]="uiArtefakt.WertEingabeMin"
                                [maxValue]="uiArtefakt.WertEingabeMax" [placeholder]="''"
                                [ngModel]="uiArtefakt.WertEingabe"
                                (inputChange)="changeValue($event, sliderValue?.valid)"
                                (blur)="onBlur()"
                                #sliderValue="ngModel" [name]="uiArtefakt.Identifikator"
                                [outerErrors]="sliderValue?.errors"
                                [isTouched]="sliderValue?.touched"
                                [required]="uiArtefakt.PflichtfeldJN" [isDirty]="sliderValue?.dirty"
                                [textForRequiredError]="uiArtefakt.FehlertextPflichtfeld"
                                [disabled]="isDisabled"
                                [autocomplete]="autocomplete">
        </lv-material-form-input>
      </div>
    </div>
    <mat-slider discrete [min]="uiArtefakt.WertEingabeMin" [max]="uiArtefakt.WertEingabeMax"
                [step]="sliderStep"
                [disabled]="isDisabled"
                class="lv-mat-slider">
      <input matSliderThumb [value]="uiArtefakt.WertEingabe" (valueChange)="setSliderValue($event)"/>
    </mat-slider>
    <div *ngIf="!!uiArtefakt.WertEingabeMin || !!uiArtefakt.WertEingabeMin"
         class="lv-slider-min-max">
      <div>{{sliderMinDescription}}</div>
      <div>{{sliderMaxDescription}}</div>
    </div>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>
